const ERROR_CODES = {
    GUEST_NOT_AVAILABLE: { code: "TC00001", name: "Guest Not Available", message: "elli.script.guest is not available.", file: "LoanForm.js" },
    AUTH_BLOCK_ERROR: { code: "TC00002", name: "Auth Block Error", message: "Authentication failed.", file: "LoanForm.js" },
    AUTH_CODE_ERROR: { code: "TC00003", name: "Create Auth Code Error", message: "Unable to generate Auth Code.", file: "LoanForm.js" },
    LOAN_PROCESS_ERROR: { code: "TC00004", name: "Loan Processing Error", message: "Loan processing failed.", file: "LoanForm.js" },
    USER_FETCH_ERROR: { code: "TC00005", name: "User Fetch Error", message: "Failed to fetch external user details.", file: "LoanForm.js" },
    FILE_UPLOAD_ERROR: { code: "TC00006", name: "File Upload Error", message: "Failed to process uploaded XML file.", file: "LoanForm.js" },
    ORG_SWITCH_FAILED: {
        code: "TC00039",
        name: "Organization Switch Error",
        message: "Failed to load contacts for selected company or branch.",
        file: "LoanForm.js"
    },
    HEADER_LOAN_ERROR: { code: "TC00007", name: "Header Loan Information Error", message: "Failed to load Header Loan Information.", file: "header.js" },
    HEADER_MILESTONE_ERROR: { code: "TC00008", name: "Header MileStone Information Error", message: "Failed to load Header MileStone Information.", file: "header.js" },
    LOS_COMMENT_LOAD_ERROR: { code: "TC00009", name: "LOS Comment Load Error", message: "Failed to load LOS Comment.", file: "losComment.js" },
    LOS_COMMENT_SAVE_ERROR: { code: "TC00010", name: "LOS Comment Save Error", message: "Failed to save LOS Comment.", file: "losComment.js" },
    TPO_COMMENT_LOAD_ERROR: { code: "TC00011", name: "TPO Comment Load Error", message: "Failed to load TPO Comment.", file: "tpoComment.js" },
    TPO_COMMENT_SAVE_ERROR: { code: "TC00012", name: "TPO Comment Save Error", message: "Failed to save TPO Comment.", file: "tpoComment.js" },

    LOAN_SUMMARY_ERROR: { code: "TC00013", name: "Loan Summary Init Error", message: "Failed to load Loan Summary Information.", file: "LoanSummary.js" },
    LOAN_SUMMARY_LOAD_ERROR: { code: "TC00014", name: "Loan Summary Load Error", message: "Loan summary data failed to load.", file: "LoanSummary.js" },
    LOAN_MILESTONE_ERROR: { code: "TC00015", name: "Loan Milestone Error", message: "Failed to fetch milestone data.", file: "LoanSummary.js" },
    LOAN_DETAILS_ERROR: { code: "TC00016", name: "Loan Details Error", message: "Failed to fetch loan details.", file: "LoanSummary.js" },
    FETCH_ATTACHMENT_ERROR: { code: "TC00017", name: "Fetch Attachment Error", message: "Failed to get Approval Certificate.", file: "LoanSummary.js" },
    DOWNLOAD_ATTACHMENT_ERROR: { code: "TC00018", name: "Download Attachment Error", message: "Attachment download failed.", file: "LoanSummary.js" },

    HEADER_LOAN_ID_FETCH_ERROR: { code: "TC00019", name: "Header Loan ID Fetch Error", message: "Failed to fetch loan ID from guest script.", file: "CustomHeader.js" },
    CUSTOM_HEADER_LOAD_ERROR: { code: "TC00020", name: "Custom Header Load Error", message: "Failed to load custom header data.", file: "CustomHeader.js" },
    CUSTOM_HEADER_TOKEN_REGEN_ERROR: {
        code: "TC00021",
        name: "Custom Header Token Regeneration Error",
        message: "Token regeneration failed during polling.",
        file: "CustomHeader.js"
    },
    CUSTOM_HEADER_POLLING_ERROR: {
        code: "TC00022",
        name: "Custom Header Polling Error",
        message: "Error occurred during polling for Loan File Sequence change.",
        file: "CustomHeader.js"
    },

    SIDEBAR_TPO_ERROR: { code: "TC00023", name: "Sidebar TPO Error", message: "Failed to load Side Bar Menu Information.", file: "SidebarMenu.js" },
    SIDEBAR_LOAD_ERROR: { code: "TC00024", name: "Sidebar Load Error", message: "Failed to load Side Bar Menu Loan Information.", file: "SidebarMenu.js" },
    SIDEBAR_REDIRECT_ERROR: { code: "TC00025", name: "Sidebar Redirect Error", message: "Loan Page Redirect failed.", file: "SidebarMenu.js" },

    COMMERCIAL_APP_LOAN_FETCH_ERROR: { code: "TC00026", name: "Commercial Loan Fetch Error", message: "Failed to fetch loan data from guest script.", file: "Index.js" },
    COMMERCIAL_APP_TOKEN_FETCH_ERROR: { code: "TC00027", name: "Token Fetch Error", message: "Failed to fetch access token for loan.", file: "Index.js" },
    COMMERCIAL_APP_FIELD_FETCH_ERROR: { code: "TC00028", name: "Field Reader Error", message: "Failed to fetch field values from Encompass.", file: "Index.js" },
    COMMERCIAL_APP_REO_VOD_SUBMIT_ERROR: { code: "TC00029", name: "REO/VOD Submission Error", message: "Failed to submit REO or VOD data to Encompass.", file: "Index.js" },
    COMMERCIAL_APP_FIELD_WRITE_ERROR: { code: "TC00030", name: "Field Write Error", message: "Failed to write loan field data to Encompass.", file: "Index.js" },
    COMMERCIAL_APP_PDF_GENERATION_ERROR: { code: "TC00031", name: "PDF Generation Error", message: "Failed to generate and upload PDF to Encompass.", file: "Index.js" },
    LIGHTNING_DOC_ERROR: { code: "TC00032", name: "Lightning doc order Error", message: "Failed to generate and upload PDF to Encompass.", file: "placeorder.js" },
    CONDITION_SNAPHOT_ERROR: { code: "TC00033", name: "Condition Snapshot Error", message: "Failed to add condition snapshot", file: "loconditions.js" },

    FILE_DROP_REJECTED: { code: "TC00034", name: "File Drop Rejected", message: "User dropped an invalid file.", file: "LoanForm.js" },
    FILE_TYPE_INVALID: { code: "TC00035", name: "Invalid File Type", message: "Only .xml files are allowed.", file: "LoanForm.js" },
    FILE_READ_ERROR: { code: "TC00036", name: "File Read Error", message: "FileReader failed to read the file.", file: "LoanForm.js" },
    NEXT_CLICK_NO_FILE: { code: "TC00037", name: "Next Click Without File", message: "User clicked Next without uploading a file.", file: "LoanForm.js" },
    MISMO_CONVERT_ERROR: { code: "TC00038", name: "MISMO Convert Error", message: "convertMismoToLoanObject failed.", file: "LoanForm.js" },
    MILESTONE_PROCESSING_PAGE_INIT_ERROR: { code: "TC00040", name: "Milestone Processing Page Init Error", message: "initializePage failed.", file: "MilestoneProcessingPage.js" },

    LOAN_APPROVAL_FETCH_ATTACHMENT_ERROR: {
        code: "TC00041",
        name: "Loan Approval Attachment Fetch Error",
        message: "Failed to fetch approval letters.",
        file: "LoanApprovalPage.js"
    },
    LOAN_APPROVAL_PAGE_INIT_ERROR: { code: "TC00042", name: "Loan Approval Page Init Error", message: "Failed to load Loan Approval page.", file: "LoanApprovalPage.js" },
    LOAN_APPROVAL_APPROVE_ERROR: { code: "TC00043", name: "Loan Approval Processing Error", message: "Failed during Loan Approval processing.", file: "LoanApprovalPage.js" },
    LOAN_APPROVAL_AM_ROUTE_ERROR: {
        code: "TC00044",
        name: "Loan Approval Account Manager Route Error",
        message: "Failed to route Account Manager milestone.",
        file: "LoanApprovalPage.js"
    },
    LOAN_APPROVAL_CREATE_CONDITION_ERROR: {
        code: "TC00045",
        name: "Loan Approval Condition Creation Error",
        message: "Failed to create the Lock Validation Required condition.",
        file: "LoanApprovalPage.js"
    },
    LOAN_APPROVAL_CLEAR_CONDITION_ERROR: {
        code: "TC00046",
        name: "Loan Approval Condition Clear Error",
        message: "Failed to clear the Lock Validation Required condition status.",
        file: "LoanApprovalPage.js"
    },
    LOAN_APPROVAL_APPROVE_API_ERROR: {
        code: "TC00047",
        name: "Loan Approval Approve API Error",
        message: "Failed to call the Loan Approval approve API.",
        file: "LoanApprovalPage.js"
    },
    APPRAISAL_ORDER_TOKEN_FETCH_ERROR: {
        code: "TC00048",
        name: "Appraisal Order Token Fetch Error",
        message: "Failed to fetch access token for appraisal order.",
        file: "AppraisalOrderPage.js"
    },
    APPRAISAL_ORDER_LOAN_FETCH_ERROR: {
        code: "TC00049",
        name: "Appraisal Order Loan Fetch Error",
        message: "Failed to fetch appraisal order loan data.",
        file: "AppraisalOrderPage.js"
    },
    APPRAISAL_ORDER_FIELD_FETCH_ERROR: {
        code: "TC00050",
        name: "Appraisal Order Field Fetch Error",
        message: "Failed to fetch appraisal order fields.",
        file: "AppraisalOrderPage.js"
    },
    APPRAISAL_ORDER_FIELD_WRITE_ERROR: {
        code: "TC00051",
        name: "Appraisal Order Field Write Error",
        message: "Failed to write appraisal order fields.",
        file: "AppraisalOrderPage.js"
    }
};

export default ERROR_CODES;
